import EmployeesPage from "./EmployeesPage"

const OnboardingPage = () => {
  return (
    <div>
      <EmployeesPage />
    </div>
  )
}

export default OnboardingPage
